export default __webpack_public_path__ + "static/media/TrainDockingFluid.256.d0cfb0ff.png";